export class Ciudades {
    nombre: string;
    id: number;

    constructor (nombre: string, id: number){
        this.nombre=nombre;
        this.id=id;
    }
}